var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMascotBaseBotAdaptive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 191,
    viewBox: "0 0 191 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mascot-Base-adaptive"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mascot-Base-bg-adaptive",
    filter: "url(#filter0_f_1877_17755)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.343,
    cy: 95.4133,
    r: 51.6594,
    fill: "#1D8DF1",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    id: "mascot-Base-icon-adaptive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M142.61 75.7151C140.939 67.8351 134.958 61.6392 131.894 58.8282C122.912 52.4593 118.144 51.7739 112.13 50.9094L112.012 50.8924C102.645 49.5458 81.9776 49.6698 73.3995 52.2135C62.6767 55.3931 56.5495 61.7524 52.9288 68.3881C49.3081 75.0238 45.1305 85.5304 47.7763 106.544C49.893 123.354 58.7777 129.492 66.2974 133.639L78.6913 139.999L93.5916 146.634C100.554 143.824 117.126 136.709 127.709 130.736C140.939 123.271 143.445 109.861 144.142 106.544C145.621 99.4931 144.411 84.2108 142.61 75.7151Z",
    fill: "url(#paint0_linear_1877_17755)",
    stroke: "black",
    strokeWidth: 1.49972
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M125.77 106.387H143.531L143.115 108.497L142.56 110.889L141.727 113.422L140.617 116.095C133.18 116.208 127.389 116.048 126.602 115.673C125.159 113.759 125.492 108.31 125.77 106.387Z",
    stroke: "black",
    strokeWidth: 1.49972
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M120.6 73.4573C122.047 66.7866 130.661 62.3709 134 61.3055C124.96 51.0887 113.667 50.5254 102.612 49.9738L102.372 49.9619C93.3295 49.5103 76.5688 50.0849 68.0034 54.1311C57.7066 58.9951 52.0017 67.7503 49.3579 75.9496C46.7142 84.1489 46.1576 98.1851 47.2708 105.273C48.5889 113.665 51.0214 127.183 62.7159 130.565C75.6564 134.308 92.0755 133.058 105.851 129.87C118.036 127.051 119.348 113.623 119.904 107.924L119.905 107.922C120.461 102.224 118.791 81.7955 120.6 73.4573Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.49972
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 13.1331,
    height: 3.38918,
    rx: 1.69459,
    transform: "matrix(-1 0 0 1 86.5469 114.859)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M105.081 111.27C108.304 106.563 116.193 106.087 119.805 106.507C119.388 114.632 118.832 118.695 115.221 123.738C112.352 127.745 107.72 129.762 102.859 130.323V118.835C102.859 114.212 104.387 112.438 105.081 111.27Z",
    stroke: "black",
    strokeWidth: 1.49972
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M125.154 74.7829C126.672 72.5389 132.12 69.5074 135.078 68.0508L138.23 76.5545C136.082 76.838 128.54 80.9245 124.921 87.5385L123.403 79.6253C123.481 79.1135 123.762 76.8416 125.154 74.7829Z",
    fill: "#CAA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M122.209 128.243L139.93 116.77L139.151 118.208L138.261 119.758C137.077 121.519 135.267 124.235 132.308 126.73C129.941 128.726 128.039 130.026 123.304 132.257L117.582 135.198L103.178 135.622L87.0797 136.151L73.523 136.575L64.6264 132.021L63.6732 131.279C74.56 134.235 94.509 133.057 105.992 130.944L122.209 128.243Z",
    fill: "#7057F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M111.118 137.312H102.388L96.0781 143.879L111.118 137.312Z",
    fill: "#383740"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M127.568 108.508H140.984L139.925 111.784L127.921 111.897C127.357 111.174 127.333 109.336 127.568 108.508Z",
    fill: "#826CF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M109.215 137.738H99.9939L93.3281 144.94L109.215 137.738Z",
    fill: "#634AE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M118.75 135.621L72.3607 137.059L77.2218 139.648L78.8885 140.511L79.9996 141.087L93.6109 147.271L100.139 144.539L106.667 141.518L118.75 135.621Z",
    fill: "#7057F0",
    stroke: "black",
    strokeWidth: 1.49972
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M111.122 137.738H100.573L94.1758 144.94L111.122 137.738Z",
    fill: "#644AE7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    width: 31.5617,
    height: 20.7587,
    rx: 4.49915,
    transform: "matrix(-1 0 0 1 116.414 80.1211)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter1_f_1877_17755)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.2081,
    cy: 8.29228,
    rx: 12.2081,
    ry: 8.29228,
    transform: "matrix(-1 0 0 1 112.969 82.5391)",
    fill: "#2DBDFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    filter: "url(#filter2_f_1877_17755)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.135,
    cy: 6.44955,
    rx: 10.135,
    ry: 6.44955,
    transform: "matrix(-1 0 0 1 110.668 84.3828)",
    fill: "#0652FF"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    width: 31.5617,
    height: 20.7587,
    rx: 4.49915,
    transform: "matrix(-1 0 0 1 82.1016 80.1211)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    filter: "url(#filter3_f_1877_17755)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.8991,
    cy: 8.75296,
    rx: 12.8991,
    ry: 8.75296,
    transform: "matrix(-1 0 0 1 79.8008 82.0781)",
    fill: "#2DBDFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    filter: "url(#filter4_f_1877_17755)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5957,
    cy: 6.91024,
    rx: 10.5957,
    ry: 6.91024,
    transform: "matrix(-1 0 0 1 77.0391 83.9219)",
    fill: "#0652FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M93.165 91.3964H102.537C102.842 91.3964 102.842 91.3964 102.843 91.0899C102.843 90.8524 102.827 90.6131 102.847 90.3769C102.868 90.1408 102.774 90.0949 102.556 90.0958C100.545 90.1034 98.5334 90.1002 96.5223 90.1002H93.1641C93.4273 86.5801 96.4737 83.4423 100.484 83.461C104.477 83.4802 107.83 86.7735 107.739 90.9125C107.655 94.8283 104.459 97.9871 100.537 98.0374C96.4933 98.0891 93.4193 94.9215 93.165 91.3964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M58.7704 91.4785H68.1421C68.4472 91.4785 68.4477 91.4785 68.4481 91.1719C68.4481 90.9344 68.4321 90.6951 68.4526 90.459C68.4731 90.2228 68.3791 90.1769 68.1617 90.1778C66.1501 90.1854 64.1389 90.1823 62.1277 90.1823H58.7695C59.0328 86.6621 62.0792 83.5243 66.0899 83.5431C70.082 83.5622 73.4353 86.8555 73.3449 90.9946C73.2602 94.9104 70.0646 98.0691 66.1425 98.1195C62.0988 98.1712 59.0248 95.0035 58.7704 91.4785Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_17755",
    x: 0.341789,
    y: 0.412102,
    width: 190.004,
    height: 190.004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6709,
    result: "effect1_foregroundBlur_1877_17755"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_17755",
    x: 85.5513,
    y: 79.5396,
    width: 30.4168,
    height: 22.5848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.49972,
    result: "effect1_foregroundBlur_1877_17755"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1877_17755",
    x: 87.399,
    y: 81.3834,
    width: 26.2684,
    height: 18.8973,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.49972,
    result: "effect1_foregroundBlur_1877_17755"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1877_17755",
    x: 51.0045,
    y: 79.0787,
    width: 31.7957,
    height: 23.5067,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.49972,
    result: "effect1_foregroundBlur_1877_17755"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1877_17755",
    x: 52.8482,
    y: 80.9224,
    width: 27.1903,
    height: 19.8192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.49972,
    result: "effect1_foregroundBlur_1877_17755"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_17755",
    x1: 134.637,
    y1: 62.8583,
    x2: 107.244,
    y2: 146.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B589FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491707,
    stopColor: "#AF86FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738033,
    stopColor: "#866FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806CF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotBaseBotAdaptive);
export default __webpack_public_path__ + "static/media/MascotBaseBotAdaptive.19a9c1699ba50c7118c362592ad2ec35.svg";
export { ForwardRef as ReactComponent };